import Search from "../../MainContent/Search/Search";
import Marquee from "../../Marquee/Marquee";

const Structure = () => {
    return (
        <div className="container">
            <Search />
            <h4 class="pb-4 pt-4 mb-4 ">
                Сохтор
            </h4>
            <div>
                <img src="https://maorif.tj/storage/posts/January2021/mpWgnPpWtcdURDuSPh3h.jpg"></img>
            </div >
            <Marquee />
        </div >
    )
}

export default Structure;